import { render, staticRenderFns } from "./SearchListBody.vue?vue&type=template&id=33c9a1bb&scoped=true&"
import script from "./SearchListBody.vue?vue&type=script&lang=js&"
export * from "./SearchListBody.vue?vue&type=script&lang=js&"
import style0 from "./SearchListBody.vue?vue&type=style&index=0&id=33c9a1bb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c9a1bb",
  null
  
)

export default component.exports